import '@qsrsoft/myq-core/styles';
import 'vuetify/dist/vuetify.css';

import App from './App.vue';
import { router, vuetify, initVueWithAuth } from '@qsrsoft/myq-core';
import { getRoutes } from '@/views/routes';
import Highcharts from 'highcharts';
import Stock from 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue';
import { i18n } from '@qsrsoft/myq-core';
import domainTranslations, { SUPPORTED_LOCALES } from '@/i18n';
import { isMultiClientUser } from '@/views/multiClient/mtEnterprises';
import { useReportOverridesStore } from '@/stores/reportOverrides';
import { installReportUsageTracking } from '@/helpers/reportUsage';

console.log('Reports Loaded, 2026-09-23', 3);

async function loadApp() {
  // trickery to get refreshing to work with multi enterprise routes
  let routes;
  let multiClient = false;
  const userString = localStorage.getItem('user');
  if (userString) {
    const user = JSON.parse(userString);
    const enterprise = user?.user?.organization?.enterpriseClient;
    const countryCode = user?.user?.organization?.countryCode;
    routes = getRoutes(enterprise, countryCode);
    multiClient = isMultiClientUser(enterprise, countryCode);
  }
  Stock(Highcharts);

  // Merge domain translations into the global vue-i18n instance
  // so Options API components using $t() can access them
  for (const locale of SUPPORTED_LOCALES) {
    i18n.global.mergeLocaleMessage(locale, domainTranslations[locale] || {});
  }

  const app = await initVueWithAuth({
    app: App,
    routes,
    vuetify,
    router,
  });
  app.use(HighchartsVue);
  if (multiClient) {
    // Enterprise report overrides: one request, cached, so a report view
    // normally finds its defaults already in memory when it mounts.
    try {
      useReportOverridesStore().load();
    } catch (err) {
      console.warn('[reportOverrides] preload skipped', err);
    }
  }
  // Report opens for the QSR Soft Admin "Report Usage" tab, every org.
  installReportUsageTracking(router);
  app.mount('#app');
}

loadApp();
